import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {concatLatestFrom} from '@ngrx/operators';
import {select, Store} from '@ngrx/store';
import {exhaustMap, filter, map, mergeMap, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthRepository} from '../../../repository/auth.repository';
import {
  getUserInfoAction,
  getUserInfoFailureAction,
  getUserInfoSuccessAction,
  updateUserInfoAction,
  updateUserInfoFailureAction,
  updateUserInfoSuccessAction,
} from '../auth.actions';
import {getUserInfoSelector} from '../auth.selectors';

@Injectable()
export class GetUserInfoEffect {

  constructor(private actions$: Actions,
              private store: Store,
              private authRepo: AuthRepository) {
  }

  // noinspection TypeScriptValidateTypes
  getUserInfo$ = createEffect(() => this.actions$.pipe(
    ofType(getUserInfoAction),
    concatLatestFrom(() => this.store.pipe(select(getUserInfoSelector))),
    filter(([, userInfo]) => !userInfo),
    exhaustMap(() => {
      return this.authRepo.getUserInfo().pipe(
        map(response => getUserInfoSuccessAction({data: response})),
        catchError((errorResponse: HttpErrorResponse) => of(getUserInfoFailureAction({error: errorResponse})))
      );
    })
  ));

  // noinspection TypeScriptValidateTypes
  updateUserInfo$ = createEffect(() => this.actions$.pipe(
    ofType(updateUserInfoAction),
    mergeMap((action) => {
      return this.authRepo.updateUserInfo(action.data).pipe(
        map(response => updateUserInfoSuccessAction({data: response})),
        catchError((errorResponse: HttpErrorResponse) => of(updateUserInfoFailureAction({
          error: errorResponse,
          id: action.data.id
        })))
      )
    })
  ));

}
